<!-- 
	Content and translations will be customized when it needs to be used,
	that's why for now it looks like this for test view.
-->

<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Container, Modal, Text, Button, IconButton } from '@Shelly/shelly-design-system';
	import { navigateToShop } from '../Lists/list-helpers';
	import { save_profile } from 'src/helpers/profile_helpers';
	import { createEventDispatcher, onMount } from 'svelte';
	import { mobile } from 'src/services/mobile-rework';
	import { version } from 'package.json';

	export let showModal = false;
	export let priority = 80;

	const dispatch = createEventDispatcher();

	$: dealDates = `<span class="text-bold">${$format('', {
		default:
			'From {startDate} to {endDate}, enjoy a 50% discount on selected Shelly devices in our web shop.',
		values: {},
	})}</span>`;
	$: mainSentence = $format('', {
		default: "{dealDates} It's the perfect time to upgrade, treat yourself, or get ahead on gifts!",
		values: { dealDates },
	});

	onMount(() => {
		if (mobile.isMobile) {
			mobile.addEventListener('back_button', closeModal);
			return () => mobile.removeEventListener('back_button', closeModal);
		}
	});

	const closeModal = (e: CustomEvent | MouseEvent) => {
		e.preventDefault();
		save_profile('promoPremium', version.split('-')[0]);
		dispatch('close');
	};
</script>

<Modal
	{showModal}
	on:close={closeModal}
	title={$format('', { default: 'Exclusive Offer Just for You!' })}
	zIndex={priority}
>
	<Container slot="content" padding="0">
		<div class="mb-m d-flex align-items-center flex-direction-column">
			<img class="mb-m" src="./images/promo_premium.svg" alt="promo-premium" />
			<p class="h1-styles text-center">
				{$format('', { default: 'Exclusive offer for you:' })}
			</p>
			<p class="h1-styles text-center text-bold text-warning">
				{$format('', { default: 'Get 50% off on selected Shelly devices' })}
			</p>
		</div>
		<Text class="mb-s">{$format('', { default: 'Dear Premium user,' })}</Text>
		<Text class="mb-m"
			>{$format('', {
				default:
					'We’re thrilled to have you as part of our Shelly Smart Control App family. As a thank you for being a Premium user, we have prepared an exclusive offer just for you.',
			})}</Text
		>
		<Text class="mb-m">{@html mainSentence}</Text>
		<Text class="text-small">
			{$format('', {
				default: 'Here’s how you can claim your offer:',
			})}
			<ul class="pl-l mt-0 mb-m">
				<li class="text-small">
					{$format('', {
						default: 'Copy your premium promo code: {code}',
						values: {},
					})}
				</li>
				<li class="text-small">
					{$format('', {
						default: 'Click on the "Shop Now" button below to head to our promo page',
					})}
				</li>
				<li class="text-small">
					{$format('', {
						default:
							'Add up to 30 items from the product selection in the cart and apply your code at checkout to slash the price in half!',
					})}
				</li>
			</ul>
		</Text>
		<div class="mb-m d-flex align-items-center flex-direction-column mb-m colored-background">
			<Text class="mb-s">{$format('', { default: 'Promo code:' })}</Text>
			<div class="d-flex align-items-center">
				<p class="h1-styles mr-s">PR10YHWPZ</p>
				<IconButton
					aria-label={$format('button_copy_promo_code', { default: 'Copy promo code' })}
					icon="fa-solid fa-copy"
				/>
			</div>
		</div>
		<Text class="mb-m"
			>{$format('', {
				default: 'You can find the full terms and conditions on the promo page.',
			})}</Text
		>
		<div class="d-flex align-items-center flex-direction-column">
			<Button
				class="mb-m"
				on:click={() => navigateToShop('https://www.shelly.com/collections/all-products')}
			>
				{$format('button_shop_now', { default: 'Shop Now' })}
			</Button>
			<Text class="link-styles" on:click={closeModal}
				>{$format('button_no_thank_you', { default: 'No, thank you!' })}</Text
			>
		</div>
	</Container>
</Modal>

<style>
	.colored-background {
		background: #182f45;
		border-radius: 12px;
		padding: 16px;
	}
</style>
